var _style, _rect, _line, _g, _path, _path2, _line2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _rect2, _rect3, _line11, _line12, _rect4, _rect5, _path14, _path15, _line13, _line14, _line15, _line16, _line17, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#135677;}\n\t.st2{opacity:0.15;fill:none;stroke:#135677;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{opacity:0.6;}\n\t.st4{opacity:0.15;}\n\t.st5{fill:none;stroke:#02283F;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#02283F;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:#FFBF73;}\n\t.st8{opacity:0.43;fill:#FFBF73;}\n\t.st9{fill:none;stroke:#135677;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:#4DCBAB;}\n\t.st11{opacity:0.49;fill:#4DCBAB;}\n\t.st12{opacity:0.21;fill:none;stroke:#72757C;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st13{opacity:0.2;fill:#72757C;}\n\t.st14{fill:#FFC88D;}\n\t.st15{opacity:0.2;fill:#FFBF73;}\n\t.st16{fill:#FFFFFF;}\n\t.st17{fill:#82818C;}\n\t.st18{fill:none;stroke:#135677;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st19{fill:#FFAA58;}\n\t.st20{fill:none;stroke:#CCE1EA;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_78_",
    className: "st0",
    width: 1000,
    height: 1000
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_59_",
    className: "st2",
    x1: 562.7,
    y1: 315.7,
    x2: 584.1,
    y2: 339.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_187_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_72_",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_70_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_67_",
    x: 108.8,
    y: 329,
    className: "st5",
    width: 152.5,
    height: 371.6
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_73_",
    className: "st5",
    x1: 142,
    y1: 698,
    x2: 142,
    y2: 329
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_74_",
    className: "st5",
    x1: 230,
    y1: 698,
    x2: 230,
    y2: 329
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_75_",
    className: "st5",
    x1: 186,
    y1: 698,
    x2: 186,
    y2: 329
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_76_",
    className: "st5",
    x1: 109,
    y1: 368,
    x2: 262,
    y2: 368
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_77_",
    className: "st5",
    x1: 109,
    y1: 387,
    x2: 262,
    y2: 387
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_80_",
    className: "st5",
    x1: 109,
    y1: 434,
    x2: 262,
    y2: 434
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_79_",
    className: "st5",
    x1: 109,
    y1: 455,
    x2: 262,
    y2: 455
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_82_",
    className: "st5",
    x1: 109,
    y1: 504,
    x2: 262,
    y2: 504
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_81_",
    className: "st5",
    x1: 109,
    y1: 525,
    x2: 262,
    y2: 525
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_85_",
    className: "st5",
    x1: 109,
    y1: 576,
    x2: 262,
    y2: 576
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_83_",
    className: "st5",
    x1: 109,
    y1: 596,
    x2: 262,
    y2: 596
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_90_",
    className: "st5",
    x1: 109,
    y1: 639,
    x2: 262,
    y2: 639
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_89_",
    className: "st5",
    x1: 109,
    y1: 658,
    x2: 262,
    y2: 658
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_71_",
    x: 142.8,
    y: 296.4,
    className: "st5",
    width: 87.7,
    height: 33.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_92_",
    x: 163.2,
    y: 263,
    className: "st5",
    width: 46.9,
    height: 33.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_69_",
    className: "st4"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_20_",
    className: "st5",
    points: "748.3,699.7 686.5,699.7 686.5,327.6 849.5,327.6 849.5,699.7 801.5,699.7   "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_23_",
    x: 707.6,
    y: 361.7,
    className: "st5",
    width: 19.7,
    height: 34.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_26_",
    x: 741.3,
    y: 361.7,
    className: "st5",
    width: 19.7,
    height: 34.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_27_",
    x: 775,
    y: 361.7,
    className: "st5",
    width: 19.7,
    height: 34.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_28_",
    x: 808.8,
    y: 361.7,
    className: "st5",
    width: 19.7,
    height: 34.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_32_",
    x: 707.6,
    y: 413.7,
    className: "st5",
    width: 19.7,
    height: 34.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_31_",
    x: 741.3,
    y: 413.7,
    className: "st5",
    width: 19.7,
    height: 34.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_30_",
    x: 775,
    y: 413.7,
    className: "st5",
    width: 19.7,
    height: 34.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_29_",
    x: 808.8,
    y: 413.7,
    className: "st5",
    width: 19.7,
    height: 34.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_38_",
    x: 707.6,
    y: 512.7,
    className: "st5",
    width: 19.7,
    height: 29.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_37_",
    x: 741.3,
    y: 512.7,
    className: "st5",
    width: 19.7,
    height: 29.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_36_",
    x: 775,
    y: 512.7,
    className: "st5",
    width: 19.7,
    height: 29.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_35_",
    x: 808.8,
    y: 512.7,
    className: "st5",
    width: 19.7,
    height: 29.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_45_",
    x: 707.6,
    y: 618.1,
    className: "st5",
    width: 19.7,
    height: 29.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_44_",
    x: 741.3,
    y: 618.1,
    className: "st5",
    width: 19.7,
    height: 29.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_43_",
    x: 775,
    y: 618.1,
    className: "st5",
    width: 19.7,
    height: 29.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_42_",
    x: 808.8,
    y: 618.1,
    className: "st5",
    width: 19.7,
    height: 29.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_33_",
    className: "st5",
    x1: 707,
    y1: 478,
    x2: 828,
    y2: 478
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_34_",
    className: "st5",
    x1: 707,
    y1: 494,
    x2: 828,
    y2: 494
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_39_",
    className: "st5",
    x1: 707,
    y1: 562,
    x2: 828,
    y2: 562
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_40_",
    className: "st5",
    x1: 707,
    y1: 579,
    x2: 828,
    y2: 579
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_41_",
    className: "st5",
    x1: 707,
    y1: 596,
    x2: 828,
    y2: 596
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_24_",
    x: 717.4,
    y: 292,
    className: "st5",
    width: 110.6,
    height: 35.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_47_",
    x: 741.3,
    y: 256.4,
    className: "st5",
    width: 62.8,
    height: 35.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_48_",
    className: "st5",
    x1: 771,
    y1: 256,
    x2: 771,
    y2: 200
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_53_",
    className: "st4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_52_",
    className: "st5",
    points: "604.7,700 520.6,700 520.6,339.1 562.7,293.2 604.7,339.1   "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st5",
    d: "M675.2,700h-70.5V409.1c0-40.6,26.7-47.2,70.5-68.3L675.2,700z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_315_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_323_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_325_",
    className: "st6",
    x1: 630,
    y1: 620,
    x2: 630,
    y2: 638
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_324_",
    className: "st6",
    x1: 649,
    y1: 620,
    x2: 649,
    y2: 638
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_300_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_305_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_310_",
    className: "st6",
    x1: 630,
    y1: 582,
    x2: 630,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_309_",
    className: "st6",
    x1: 649,
    y1: 582,
    x2: 649,
    y2: 600
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_283_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_290_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_293_",
    className: "st6",
    x1: 630,
    y1: 544,
    x2: 630,
    y2: 562
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_291_",
    className: "st6",
    x1: 649,
    y1: 544,
    x2: 649,
    y2: 562
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_269_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_276_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_278_",
    className: "st6",
    x1: 630,
    y1: 506,
    x2: 630,
    y2: 524
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_277_",
    className: "st6",
    x1: 649,
    y1: 506,
    x2: 649,
    y2: 524
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_255_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_262_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_264_",
    className: "st6",
    x1: 630,
    y1: 468,
    x2: 630,
    y2: 486
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_263_",
    className: "st6",
    x1: 649,
    y1: 468,
    x2: 649,
    y2: 486
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_244_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_248_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_250_",
    className: "st6",
    x1: 630,
    y1: 430,
    x2: 630,
    y2: 448
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_249_",
    className: "st6",
    x1: 649,
    y1: 430,
    x2: 649,
    y2: 448
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_234_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_238_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_240_",
    className: "st6",
    x1: 630,
    y1: 392,
    x2: 630,
    y2: 410
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_239_",
    className: "st6",
    x1: 649,
    y1: 392,
    x2: 649,
    y2: 410
  })))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st5",
    d: "M449.8,700h70.5V409.1c0-40.6-26.7-47.2-70.5-68.3L449.8,700z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_54_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_322_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_326_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_328_",
    className: "st6",
    x1: 492,
    y1: 620,
    x2: 492,
    y2: 638
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_327_",
    className: "st6",
    x1: 474,
    y1: 620,
    x2: 474,
    y2: 638
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_312_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_316_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_318_",
    className: "st6",
    x1: 492,
    y1: 582,
    x2: 492,
    y2: 600
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_317_",
    className: "st6",
    x1: 474,
    y1: 582,
    x2: 474,
    y2: 600
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_302_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_306_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_308_",
    className: "st6",
    x1: 492,
    y1: 544,
    x2: 492,
    y2: 562
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_307_",
    className: "st6",
    x1: 474,
    y1: 544,
    x2: 474,
    y2: 562
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_292_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_296_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_298_",
    className: "st6",
    x1: 492,
    y1: 506,
    x2: 492,
    y2: 524
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_297_",
    className: "st6",
    x1: 474,
    y1: 506,
    x2: 474,
    y2: 524
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_279_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_286_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_288_",
    className: "st6",
    x1: 492,
    y1: 468,
    x2: 492,
    y2: 486
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_287_",
    className: "st6",
    x1: 474,
    y1: 468,
    x2: 474,
    y2: 486
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_265_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_272_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_274_",
    className: "st6",
    x1: 492,
    y1: 430,
    x2: 492,
    y2: 448
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_273_",
    className: "st6",
    x1: 474,
    y1: 430,
    x2: 474,
    y2: 448
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_251_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_258_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_260_",
    className: "st6",
    x1: 492,
    y1: 392,
    x2: 492,
    y2: 410
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_259_",
    className: "st6",
    x1: 474,
    y1: 392,
    x2: 474,
    y2: 410
  })))), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_55_",
    className: "st5",
    x1: 546,
    y1: 352,
    x2: 546,
    y2: 611
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_56_",
    className: "st5",
    x1: 582,
    y1: 352,
    x2: 582,
    y2: 611
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_181_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_182_",
    className: "st5",
    x1: 534.6,
    y1: 604,
    x2: 590.1,
    y2: 604
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_178_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_179_",
    className: "st5",
    x1: 534.6,
    y1: 566,
    x2: 590.1,
    y2: 566
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_175_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_176_",
    className: "st5",
    x1: 534.6,
    y1: 528,
    x2: 590.1,
    y2: 528
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_172_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_173_",
    className: "st5",
    x1: 534.6,
    y1: 490,
    x2: 590.1,
    y2: 490
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_169_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_170_",
    className: "st5",
    x1: 534.6,
    y1: 452,
    x2: 590.1,
    y2: 452
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_166_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_167_",
    className: "st5",
    x1: 534.6,
    y1: 414,
    x2: 590.1,
    y2: 414
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_163_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_164_",
    className: "st5",
    x1: 534.6,
    y1: 376,
    x2: 590.1,
    y2: 376
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_61_",
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_57_",
    x: 286.8,
    y: 293.2,
    className: "st5",
    width: 147.1,
    height: 406.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_60_",
    x: 306.4,
    y: 323.4,
    className: "st5",
    width: 17.3,
    height: 288.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_63_",
    x: 337,
    y: 323.4,
    className: "st5",
    width: 17.3,
    height: 288.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_64_",
    x: 367.7,
    y: 323.4,
    className: "st5",
    width: 17.3,
    height: 288.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_65_",
    x: 398.3,
    y: 323.4,
    className: "st5",
    width: 17.3,
    height: 288.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_62_",
    x: 367.7,
    y: 252,
    className: "st5",
    width: 47.9,
    height: 41.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_68_",
    className: "st5",
    x1: 390,
    y1: 252,
    x2: 390,
    y2: 216
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_66_",
    x: 304.5,
    y: 266.3,
    className: "st5",
    width: 45.4,
    height: 26.9
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st7",
    d: "M209.8,388.5c-8.7-7-21-7-29.7,0c-30,24.4-66.1,72.3-61.8,127.9c1.1,13.5,4.4,26.4,9.1,38.7  c0.3,0.9,0.7,1.7,1.2,2.6c31.6,59.1,101.1,59.1,132.6,0c0.4-0.8,0.8-1.7,1.2-2.6c4.8-12.2,8.1-25.2,9.1-38.7  C276,460.7,239.9,412.9,209.8,388.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_180_",
    className: "st8",
    d: "M234.7,566.7c-35,0-63.3-44.3-63.3-99c0-35.3,11.8-66.2,29.6-83.8c-7.1-1.9-14.8-0.4-20.8,4.5  c-30,24.4-66.1,72.3-61.8,127.9c1.1,13.5,4.4,26.4,9.1,38.7c0.3,0.9,0.7,1.7,1.2,2.6c31.6,59.1,101.1,59.1,132.6,0  c0,0,0-0.1,0.1-0.1C253.3,563.4,244.2,566.7,234.7,566.7z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_22_",
    className: "st9",
    x1: 195,
    y1: 698,
    x2: 195,
    y2: 485
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_115_",
    className: "st7",
    d: "M98,700.9c0-31.4,25.5-56.9,56.9-56.9s56.9,25.5,56.9,56.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st8",
    d: "M170.5,646.2c-4.9-1.4-10.1-2.2-15.5-2.2c-31.4,0-56.9,25.5-56.9,56.9h31.1  C129.1,674.9,146.6,652.9,170.5,646.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_91_",
    className: "st10",
    d: "M285.6,628.2c-1.9-16.2,0.8-52.2,8.7-76.1c5.2-15.7,10-37.2,31.4-49.1   c17.6-9.9,131.6-18,195.4-11.5c35.6,3.6,65.1,38.5,83.5,67.5c60.6,11.1,62.1,11.1,76.3,15.5c14.2,4.3,28.1,15.2,28.1,31.5   c0,10.5,0,39.7,0,39.7H287.3C286.7,635.7,286.2,638.1,285.6,628.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_189_",
    className: "st11",
    d: "M681.9,571.4c-14.2-4.3-15.7-4.3-76.3-15.5c-18.4-29-47.9-63.9-83.5-67.5   c-63.8-6.5-177.8,1.6-195.4,11.5c-4.8,2.7-8.7,5.9-12.1,9.3c0,0,0.1,0,0.1-0.1c17.6-9.9,131.6-18,195.4-11.5   c33.5,3.4,64,34.6,82.7,62.4c2.2,3.3,5.7,5.5,9.6,6.2c54.3,10,53.7,10.1,67.5,14.3c14.2,4.3,28.1,15.2,28.1,31.5c0,6.7,0,21,0,30.4   h12c0,0,0-29.2,0-39.7C710,586.6,696.1,575.7,681.9,571.4z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_174_",
    className: "st12",
    x1: 515,
    y1: 553.7,
    x2: 515,
    y2: 642.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_177_",
    className: "st12",
    x1: 375,
    y1: 553.7,
    x2: 372.7,
    y2: 642.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_183_",
    className: "st13",
    d: "M324.8,552.1c5.2-15.7,10-37.2,31.4-49.1c12.1-6.8,69.5-12.7,125-13.7   c-63-1.2-141.1,5.6-155.5,13.7c-21.4,12-26.2,33.4-31.4,49.1c-7.9,23.9-10.5,59.9-8.7,76.1c0.6,9.9,1.1,7.5,1.7,17.5h30.5   c-0.6-10-1.1-7.6-1.7-17.5C314.2,612,316.9,576,324.8,552.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st9",
    d: "M285.6,628.2c-1.9-16.2,0.8-52.2,8.7-76.1c5.2-15.7,10-37.2,31.4-49.1   c17.6-9.9,131.6-18,195.4-11.5c33.4,3.4,61.4,34.3,79.9,62c2.4,3.5,6.1,6,10.3,6.7c54,9.9,55.9,10.1,69.6,14.2   c14.2,4.3,28.1,15.2,28.1,31.5c0,10.5,0,39.7,0,39.7H287.3C286.7,635.7,286.2,638.1,285.6,628.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    className: "st14",
    d: "M515.1,559.3c-7.4-23.9-20.2-44.7-29.5-57.8c12.9,0.5,24.3,1.4,34.1,2.5   c29.6,3.5,54,31.5,70.3,56.5L515.1,559.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_186_",
    className: "st15",
    d: "M530.2,539.5c-5.5-10,2.4-22,13.7-20.9c2.1,0.2,4.1,0.4,6.1,0.7c1.7,0.2,3.4,0.5,5,0.9   c-10.6-8.5-22.5-14.6-35.3-16.1c-9.8-1.2-21.3-2-34.1-2.5c9.3,13.1,22.1,33.9,29.5,57.8l24.9,0.4   C537,552.5,533.6,545.7,530.2,539.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st9",
    d: "M515.1,559.3c-7.4-23.9-20.2-44.7-29.5-57.8c12.9,0.5,24.3,1.4,34.1,2.5   c29.6,3.5,54,31.5,70.3,56.5L515.1,559.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_100_",
    className: "st14",
    d: "M385,558.3l4.3-53.2c23.3-1.7,49-2.5,72.6-2.4c2.5,0,5,0,7.4,0.1c9,11.2,23.8,31.9,32.5,56.2   L385,558.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_185_",
    className: "st15",
    d: "M403.1,532c0.7-9.2,9.1-16.5,19.6-17.1c17.3-0.9,35.2-1.3,52.1-1.2c0.9,0,1.8,0,2.8,0   c-3-4.3-5.8-8-8.3-11c-2.5,0-4.9-0.1-7.4-0.1c-23.6-0.1-49.3,0.7-72.6,2.4l-4.3,53.2l16,0.1L403.1,532z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st9",
    d: "M385,558.3l4.3-53.2c23.3-1.7,49-2.5,72.6-2.4c2.5,0,5,0,7.4,0.1c9,11.2,23.8,31.9,32.5,56.2   L385,558.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_93_",
    className: "st16",
    d: "M356.8,658.8h-73.4c-9.9,0-18-8.1-18-18v0c0-9.9,8.1-18,18-18h73.4V658.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_190_",
    className: "st13",
    d: "M286.8,645.6c0-9.9,8.1-18,18-18h51.9v-4.7h-73.4c-9.9,0-18,8.1-18,18v0c0,9.9,8.1,18,18,18   h9.4C289.1,655.6,286.8,650.8,286.8,645.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st9",
    d: "M356.8,658.8h-73.4c-9.9,0-18-8.1-18-18v0c0-9.9,8.1-18,18-18h73.4V658.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_99_",
    className: "st16",
    d: "M712,658.8h-60.1v-30H712c8.3,0,15,6.7,15,15v0C727,652.1,720.3,658.8,712,658.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_192_",
    className: "st13",
    d: "M655.8,640.4H716c4.3,0,8.2,1.9,11,4.8c0-0.5,0.1-0.9,0.1-1.4v0c0-8.3-6.7-15-15-15h-60.1v30   h4V640.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st9",
    d: "M712,658.8h-60.1v-30H712c8.3,0,15,6.7,15,15v0C727,652.1,720.3,658.8,712,658.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_96_",
    x: 389.9,
    y: 642.8,
    className: "st16",
    width: 185.5,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_160_",
    x: 389.9,
    y: 642.8,
    className: "st13",
    width: 185.5,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_10_",
    x: 389.9,
    y: 642.8,
    className: "st9",
    width: 185.5,
    height: 16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_97_",
    className: "st17",
    cx: 620.3,
    cy: 655.1,
    r: 44.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_17_",
    className: "st9",
    cx: 620.3,
    cy: 655.1,
    r: 44.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_98_",
    className: "st16",
    cx: 620.3,
    cy: 655.1,
    r: 24.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_16_",
    className: "st9",
    cx: 620.3,
    cy: 655.1,
    r: 24.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_15_",
    className: "st9",
    cx: 620.3,
    cy: 655.1,
    r: 7.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st9",
    d: "M534.5,645.6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_94_",
    className: "st17",
    cx: 362.4,
    cy: 655.1,
    r: 44.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_11_",
    className: "st9",
    cx: 362.4,
    cy: 655.1,
    r: 44.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_95_",
    className: "st16",
    cx: 362.4,
    cy: 655.1,
    r: 24.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_13_",
    className: "st9",
    cx: 362.4,
    cy: 655.1,
    r: 24.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_14_",
    className: "st9",
    cx: 362.4,
    cy: 655.1,
    r: 7.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    className: "st14",
    d: "M376.8,504.1c-26.5,2.8-40.1,6.3-44.1,8.7c-15.7,9.6-20.5,25.8-24.7,40.1   c-0.5,1.6-0.9,3.1-1.4,4.6c-0.1,0.4-0.2,0.8-0.4,1.2h66.9L376.8,504.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_184_",
    className: "st15",
    d: "M323.3,558.1c4.2-14.3,8.9-30.5,24.7-40.1c3.1-1.9,12.1-4.4,28.4-6.7l0.5-7.2   c-26.5,2.8-40.1,6.3-44.1,8.7c-15.7,9.6-20.5,25.8-24.7,40.1c-0.5,1.6-0.9,3.1-1.4,4.6c-0.1,0.4-0.2,0.8-0.4,1.2h16.7   C323.2,558.5,323.2,558.3,323.3,558.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    className: "st9",
    d: "M376.8,504.1c-26.5,2.8-40.1,6.3-44.1,8.7c-15.7,9.6-20.5,25.8-24.7,40.1   c-0.5,1.6-0.9,3.1-1.4,4.6c-0.1,0.4-0.2,0.8-0.4,1.2h66.9L376.8,504.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_111_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M717.1,597.8c1.1,6.8-5.2,12.4-15.2,13.3c-9.5,0.9-20.4-3.3-22.2-10.1c-1.1-6.8,10.3-12.9,19.9-13.8    C709.1,586.3,715.8,591,717.1,597.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_110_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M717.1,597.8c1.1,6.8-5.2,12.4-15.2,13.3c-9.5,0.9-20.4-3.3-22.2-10.1c-1.1-6.8,10.3-12.9,19.9-13.8    C709.1,586.3,715.8,591,717.1,597.8z"
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_113_",
    className: "st9",
    x1: 544,
    y1: 576.7,
    x2: 525,
    y2: 576.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_114_",
    className: "st9",
    x1: 407,
    y1: 576.7,
    x2: 387,
    y2: 576.7
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    className: "st18",
    d: "M215.8,455.5c-3.6,4.1-4.5,9.6-3.1,14.5c4.6,0.2,9.2-1.6,12.4-5.3c3.6-4.1,4.5-9.6,3.1-14.5  C223.7,450,219.1,451.8,215.8,455.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_137_",
    className: "st18",
    d: "M188,425.1c-0.2,5.3,2.4,10,6.5,12.9c3.6-2.7,6-6.8,6.2-11.6c0.2-5.3-2.4-10-6.5-12.9  C190.6,416.1,188.2,420.3,188,425.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    className: "st18",
    d: "M158.1,471.3c1.4,5.3,5.3,9.2,10.2,10.8c2.7-3.7,3.9-8.5,2.6-13.3c-1.4-5.3-5.3-9.2-10.2-10.8  C157.9,461.7,156.8,466.6,158.1,471.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_146_",
    className: "st18",
    d: "M92.2,589.3c-1.2,5.3,0.6,10.6,4.2,14.3c4.1-2,7.3-5.8,8.4-10.6c1.2-5.3-0.6-10.6-4.2-14.3  C96.4,580.7,93.3,584.5,92.2,589.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    className: "st18",
    d: "M225.3,546.7c-3.6,3.2-5.1,8-4.4,12.5c4,0.7,8.3-0.4,11.6-3.4c3.6-3.2,5.1-8,4.4-12.5  C232.8,542.7,228.5,543.8,225.3,546.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_128_",
    className: "st9",
    d: "M164.3,538c0,0,9.2,24.7,30.7,26.3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    className: "st9",
    d: "M194.9,538.6c0,0,19.5-8.4,21.1-28.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_145_",
    className: "st7",
    d: "M143.8,697c-5.1-14.2-18.7-24.3-34.7-24.3S79.6,682.8,74.4,697H143.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_102_",
    className: "st19",
    d: "M121.7,674.9c-3.9-1.4-8.1-2.2-12.6-2.2c-16,0-29.5,10.1-34.7,24.3h25.1  C103.3,686.7,111.4,678.6,121.7,674.9z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_3_",
    className: "st9",
    x1: 267.5,
    y1: 699.7,
    x2: 68.1,
    y2: 699.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_5_",
    className: "st9",
    x1: 748.3,
    y1: 699.7,
    x2: 283,
    y2: 699.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_2_",
    className: "st9",
    x1: 782.7,
    y1: 699.7,
    x2: 769,
    y2: 699.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_84_",
    className: "st9",
    x1: 931.9,
    y1: 699.7,
    x2: 799.8,
    y2: 699.7
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_143_",
    className: "st9",
    x1: 155,
    y1: 666,
    x2: 155,
    y2: 697
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_144_",
    className: "st9",
    x1: 174.7,
    y1: 678,
    x2: 155,
    y2: 697
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_147_",
    className: "st18",
    x1: 887,
    y1: 442,
    x2: 887,
    y2: 697
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_148_",
    className: "st18",
    x1: 841.7,
    y1: 397.1,
    x2: 887,
    y2: 442.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_122_",
    x: 822.3,
    y: 421.5,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 553.0488 -472.6724)",
    className: "st7",
    width: 49.5,
    height: 19.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_140_",
    x: 822.3,
    y: 421.5,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 553.0488 -472.6724)",
    className: "st18",
    width: 49.5,
    height: 19.6
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_121_",
    className: "st18",
    x1: 899.7,
    y1: 490,
    x2: 899.7,
    y2: 697
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_118_",
    className: "st18",
    x1: 944.9,
    y1: 445.1,
    x2: 899.7,
    y2: 490.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_101_",
    x: 914.8,
    y: 469.5,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1942.8821 153.7374)",
    className: "st7",
    width: 49.5,
    height: 19.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_117_",
    x: 914.8,
    y: 469.5,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1942.8821 153.7374)",
    className: "st18",
    width: 49.5,
    height: 19.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    className: "st20",
    d: "M808.7,163.5c0.1-0.7,0.1-1.5,0.1-2.2c0-14.8-12-26.7-26.7-26.7c-5.7,0-11,1.8-15.3,4.8  c-3.2-11.2-13.5-19.3-25.7-19.3c-2.1,0-4.1,0.2-6.1,0.7c-6.7-7.5-16.5-12.3-27.4-12.3c-18.7,0-34.2,14-36.5,32.1  c-0.4,0-0.8-0.1-1.3-0.1c-11.5,0-20.8,9.3-20.8,20.8c0,0.7,0,1.5,0.1,2.2H808.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_162_",
    className: "st20",
    d: "M191.2,174.1c-4.5-6.4-12-10.7-20.5-10.7c-2,0-3.9,0.2-5.7,0.7c-6.3-7-15.5-11.5-25.7-11.5  c-17.5,0-32,13.1-34.1,30c-0.4,0-0.8-0.1-1.2-0.1c-10.7,0-19.5,8.7-19.5,19.5c0,0.7,0,1.4,0.1,2.1h101.9"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_165_",
    className: "st20",
    x1: 272,
    y1: 212.3,
    x2: 358.1,
    y2: 212.3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_168_",
    className: "st20",
    x1: 331.2,
    y1: 234.4,
    x2: 352.1,
    y2: 234.4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_171_",
    className: "st20",
    x1: 307.3,
    y1: 222.1,
    x2: 345.9,
    y2: 222.1
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_188_",
    className: "st20",
    x1: 527.4,
    y1: 93,
    x2: 592.6,
    y2: 93
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_191_",
    className: "st20",
    x1: 562.7,
    y1: 108.5,
    x2: 640,
    y2: 108.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_194_",
    className: "st20",
    d: "M257.1,204.1c0.9-2.1,1.4-4.4,1.4-6.9c0-9.3-7.4-16.8-16.6-16.8c-2.3,0-4.5,0.5-6.5,1.3  c-3.7-9.9-13.2-17-24.3-17c-13.3,0-24.2,10-25.7,22.8c-1.1-0.2-2.2-0.4-3.3-0.4c-8.4,0-15.1,6.6-15.1,14.7c0,0.7,0.1,1.5,0.2,2.2  H257.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.6b6801e7d9c7cd468e1994e7c684bc9c.svg";
export { ForwardRef as ReactComponent };